var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"color":_vm.color,"outlined":_vm.outlined,"retain-focus-on-click":_vm.retainFocusOnClick,"min-width":_vm.minWidth,"tile":_vm.tile}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }